module.exports = __webpack_public_path__ + "static/media/img36.37eda9da.jpg";